<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.smeltingPreheatingKilnPara')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/smeltingPreheatingKilnPara">
              <span>{{$t('tlt.smeltingPreheatingKilnPara')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("lbl.basic.startTime") }} :</label>
                  <mmf-datepicker v-model="startTimeFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("lbl.basic.endTime") }} :</label>
                  <mmf-datepicker v-model="endTimeFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                    <label class="control-label">{{$t('lbl.fm.locationName')}}：</label>
                    <select class="form-control" v-model="locNameFilter">
                      <option value="default">{{$t("lbl.basic.select.one")}}</option>
                      <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                      <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                      <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                    </select>
                </div>
                <!-- <div class="form-group col-md-2">
                  <label class="control-label">
                    <span class="lbl-required"></span>
                    {{ $t("lbl.basic.furnaceName") }}:
                  </label>
                  <input class="form-control" type="text" v-model="furnaceCodeFilter" />
                  <select class="form-control" v-model="furnaceNameFilter">
                                        <option value="default">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                    </select>
                </div> -->
                <div class="form-group col-md-2">
                  <label class="control-label">
                    {{$t('lbl.shiftPlan.shiftName')}}:
                  </label>
                  <!-- <input class="form-control" type="text" v-model="shiftNameFilter" /> -->
                  <select class="form-control" type="text" v-model="shiftNameFilter">
                    <option value="default">{{ $t("lbl.basic.select.one") }}</option>
                    <option value="甲">{{ $t("lbl.shift.A") }}</option>
                    <option value="乙">{{ $t("lbl.shift.B") }}</option>  
                    <option value="丙">{{ $t("lbl.shift.C") }}</option>
                  </select>
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('smeltingPreheatingKilnPara')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('smeltingPreheatingKilnPara')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="smeltingPreheatingKilnParaRecordTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <mmf-table entity="smeltingPreheatingKilnPara" inline-actions-disabled singleChoice>
                <div slot="btnList" class="btn-group">
                  <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToKilnStop()">
                    <i class="fas fa-tasks"></i>
                    <span class="text">{{$t('tlt.smeltingPreheatingKilnStop')}}</span>
                  </button>
                  <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToPelletFeeding()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.pelletFeeding')}}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/productionExecution/smelting/SmeltingPreheatingKilnPara";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "smeltingPreheatingKilnPara/getField",
  mutationType: "smeltingPreheatingKilnPara/updateField"
});
export default {
    name: "smeltingPreheatingKilnParaRecord",
    data(){
      return {

      }
    },
    components: { MmfTable, MmfDatepicker },
    computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.smeltingPreheatingKilnPara.rows,
      tableColumns: gridFields,
      entity: state => state.smeltingPreheatingKilnPara.entity,
      checkedItems: state => state.smeltingPreheatingKilnPara.checkedItems,
      showNoResultAlert: state => state.base.showNoResultAlert
    })
    },
    methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    jumpToKilnStop() {
      this.$router.push("/prd/smeltingPreheatingKilnStop");
    },
    jumpToPelletFeeding() {
        this.$router.push("/prd/pelletFeeding");
    }
    },
    mounted() {}
}
</script>